import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["themeSlug", "themeMode", "codeTheme", "customCss"]

  prepare() {
    const slug = document.querySelector('input[name="site[theme_slug]"]:checked')?.value
    const mode = document.querySelector('select[name="site[theme_mode]"]')?.value
    const css = document.querySelector('textarea[name="site[custom_css]"]')?.value

    if (slug) this.themeSlugTarget.value = slug
    if (mode) this.themeModeTarget.value = mode
    this.customCssTarget.value = css || ""
  }

  prepareCodeTheme() {
    const codeTheme = document.querySelector('input[name="site[code_theme]"]:checked')?.value
    if (codeTheme && this.hasCodeThemeTarget) this.codeThemeTarget.value = codeTheme
  }

  updateMode() {
    const mode = document.querySelector('select[name="site[theme_mode]"]')?.value || "auto"
    document.querySelectorAll(".theme-preview").forEach(el => {
      el.setAttribute("data-theme-mode", mode)
    })
  }
}
